var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallmoder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3334 27.3333H0.666748V0.666626H27.3334V27.3333ZM2.88897 25.1111H25.1112V2.88885H2.88897V25.1111Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.778 18.4444H6.22241V16.2222H7.33352C7.67797 16.1666 8.44463 15.3999 8.44463 12.8888C8.37255 11.5904 8.78854 10.312 9.61089 9.3046C10.4332 8.29722 11.6025 7.63371 12.8891 7.44439V6.22217H15.1113V7.44439C16.3979 7.63371 17.5671 8.29722 18.3895 9.3046C19.2118 10.312 19.6278 11.5904 19.5557 12.8888C19.5557 15.3666 20.3002 16.1555 20.6669 16.2222H21.778V18.4444ZM10.278 16.2222H18.0557C17.6467 15.1599 17.454 14.0266 17.4891 12.8888C17.5131 12.4448 17.4434 12.0006 17.2844 11.5853C17.1254 11.17 16.8807 10.7928 16.5662 10.4784C16.2518 10.1639 15.8746 9.9192 15.4593 9.7602C15.044 9.60119 14.5998 9.53144 14.1557 9.5555C13.7121 9.5332 13.2687 9.60415 12.8542 9.76377C12.4397 9.9234 12.0632 10.1682 11.7492 10.4822C11.4351 10.7963 11.1903 11.1728 11.0307 11.5873C10.8711 12.0018 10.8001 12.4452 10.8224 12.8888C10.8639 14.0251 10.6789 15.1582 10.278 16.2222Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.111 19.5554H12.8888V21.7776H15.111V19.5554Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallmoder);
export default __webpack_public_path__ + "static/media/call moder.e0158d6cadd205035312e511d7963bcf.svg";
export { ForwardRef as ReactComponent };